import {
  DndContext,
  closestCenter,
  PointerSensor,
  TouchSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  arrayMove,
  sortableKeyboardCoordinates,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import {
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
} from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import ImageTemplateBlue from "../../components/JournalImageTemplate/ImageTemplate/ImageTemplateBlue";
import ImageTemplateCyan from "../../components/JournalImageTemplate/ImageTemplate/ImageTemplateCyan";
import ImageTemplatePink from "../../components/JournalImageTemplate/ImageTemplate/ImageTemplatePink";
import VideoTemplateBlue from "../../components/JournalImageTemplate/VideoTemplate/VideoTemplateBlue";
import PreDefineTemplate1 from "../../components/JournalImageTemplate/PreDesinedTemplate/PreDesinedTemplate1";
import PreDefineTemplate2 from "../../components/JournalImageTemplate/PreDesinedTemplate/PreDesinedTemplate2";
// import PreDefineTemplate3 from "../../components/JournalImageTemplate/PreDesinedTemplate/PreDesinedTemplate3";
import PreDefineTemplate3 from "../../components/JournalImageTemplate/PreDesinedTemplate/PreDesinedTemplate4";
// import PreDefineTemplate5 from "../../components/JournalImageTemplate/PreDesinedTemplate/PreDesinedTemplate5";
import PreDefineTemplate4 from "../../components/JournalImageTemplate/PreDesinedTemplate/PreDesinedTemplate6";
import TextTemplateBlue from "../../components/JournalImageTemplate/TextTemplate/TextTemplateBlue";
import TextTemplateCyan from "../../components/JournalImageTemplate/TextTemplate/TextTemplateCyan";
import TextTemplateWhite from "../../components/JournalImageTemplate/TextTemplate/TextTemplateWhite";
import { useNotification } from "../../hooks/useNotification.js";
import { JournalAPIService } from "../../services/api/JournalAPIService";
import { API_ERROR_MESSAGE, API_SUCCESS_MESSAGE } from "../../shared/constants";
import dragIcon from "../../assests/Images/drag1.svg";
import bundle from "../../assests/Images/bundle.png";
import "./journal.css";
import FloatingActionMenu from "../Extra/FloatingActionMenu.js";
import MemorySelector from "./MemorySelector.js";
import { ArrowLeftOutlined, CloseCircleFilled } from "@ant-design/icons";
import VideoCardTemplate from "../../components/JournalImageTemplate/VideoTemplate/VideoTemplate.js";
import { UserApiService } from "../../services/api/UserAPIService.js";

// Sortable Card Wrapper
function SortableItem({ id, children,video,reel }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    border: isDragging ? "2px dashed #1976d2" : "none",
    borderRadius: 4,
    backgroundColor: "transparent",
    boxSizing: "border-box",
  };

  return (
    <Box
      ref={setNodeRef}
      {...attributes} // DO NOT spread listeners here
      sx={{
        ...style,
        flex: {
          xs: "1 0 calc(50% - 8px)",
          sm: "1 0 calc(50% - 8px)",
          md: "1 0 calc(33.33% - 8px)",
          lg: "1 0 calc(25% - 8px)",
        },
        maxWidth: {
          xs: "calc(50% - 8px)",
          sm: "calc(50% - 8px)",
          md: "calc(33.33% - 8px)",
          lg: "calc(25% - 8px)",
        },
        m: "4px",
        position: "relative",
      }}
    >
      {/* Drag Handle */}
      <Box
        {...listeners}
        sx={{
          position: "absolute",
          top: 44,
          // left: 10,
          // right:12,
          cursor: "grab",
          zIndex: 1001,
          // background:"#ffffffc9",
          padding:"4px 0px 0px 4px",
          // borderRadius:"50%",
          height:reel? "240px" : "280px",
          width:"98%",
         "@media (max-width: 440px)": {
            height: reel ? "50px" : video ? "20px" :"170px",
            width: "75%",
            left:20,
            top:40,
          },
          touchAction: "none",
        }}
      >
        {/* <img src={dragIcon} alt="drag" className="drag-icon" /> */}
      </Box>
      {(reel || video) &&
      <>
      <Box  {...listeners} sx={{    position: "absolute",
    height: "190px",
    width: "20%",
    left: "15px",
    top: "40px",
    zIndex: 1001,
    touchAction: "none",
    cursor: "grab"}}> </Box>
        <Box  {...listeners} sx={{    position: "absolute",
    height: "190px",
    width: "20%",
    right: "15px",
    zIndex: 1001,
    touchAction: "none",
    cursor: "grab",

    top: "40px"}}> </Box>

        <Box  {...listeners} sx={{    position: "absolute",
    height: "70px",
    width: "80%",
    left: "15px",
    zIndex: 1001,
    touchAction: "none",
    cursor: "grab",

    top: "160px"}}> </Box>
    </>
}

      {isDragging && (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2000,
            // backgroundColor: "rgba(255, 255, 255, 0.7)",
            // borderRadius: "50%",
            // padding: 2,
            // boxShadow: 3,
          }}
        >
          <img src={dragIcon} alt="drag" className="drag-icon" />
          {/* <DragIndicatorIcon fontSize="large" color="primary" /> */}
        </Box>
      )}

      {children}
    </Box>
  );
}

function MemoryRender({ user_phone }) {
  const { phoneNumber: phone } = useParams();
  const { notifyError } = useNotification();

  const [data, setData] = useState([]);
  const [sequenceData,setSequenceData] = useState([]);
  const [sequenceCreation,setSequenceCreation] = useState(false);
  const [sequenceId, setSequenceId] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [infoOpen, setinfoOpen] = useState(false);
  const [downloadJournal, setDownloadJournal] = useState(false);

  const [userInfo,setUserInfo] = useState({});

  const pageSize = 100;

  const observer = useRef();

  useEffect(() => {
    fetchJournal(page);
  }, [page]);

  const pageRefresh = () => {
    setPage(1);
    fetchJournal(1);
  };

  const fetchJournal = (pageToFetch) => {
    setLoading(true);

    JournalAPIService.journalListing(phone || user_phone, pageToFetch, pageSize)
      .then((response) => {
        const entries = response?.entries || [];
        const sequenceEntry = response?.sequence_entries?.[0];
        const sequenceIds = sequenceEntry?.sequence || [];
        const sequenceId = sequenceEntry?.id || "";

        setUserInfo(response?.user_info?.[0]);

        const journalFlag = String(response?.user_info?.[0]?.journalFlag).trim().toLowerCase();

        if (journalFlag !== "true")
        {
          setinfoOpen(true);
        }

        setSequenceId(sequenceId);

        if(sequenceIds?.length <= 0)
        {
          setSequenceCreation(true);
        }

        const allEntryIds = entries.map((e) => e.id);

        // Merge missing IDs into sequenceIds
        const missingIds = allEntryIds.filter((id) => !sequenceIds.includes(id));
        const finalSequence = [...sequenceIds, ...missingIds];
        setSequenceData(finalSequence); // Store for future use

        // Create a map of all entries
        const entryMap = Object.fromEntries(entries.map((item) => [item.id, item]));

        // Sort entries according to updated sequence
        const sortedEntries = finalSequence.map((id) => entryMap[id]).filter(Boolean);

        if (pageToFetch === 1) {
          setData(sortedEntries);
        } else {
          setData((prev) => [...prev, ...sortedEntries]);
        }

        if (entries.length < pageSize) {
          setHasMore(false);
        }
      })
      .catch((err) => {
        notifyError(
          err?.response?.data?.message || API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
        );
      })
      .finally(() => setLoading(false));
  };

  const lastItemRef = useCallback(
    (node) => {
      if (loading || !hasMore) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setPage((prev) => prev + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const renderTemplateComponent = (template, index) => {
    const textTemplates = [TextTemplateBlue, TextTemplateWhite, TextTemplateCyan];
    const imageTemplates = [ImageTemplateBlue, ImageTemplatePink, ImageTemplateCyan];
    const videoTemplates = [VideoTemplateBlue];

    if (template.uploaded_by === "system") {
      const preDefined = [
        PreDefineTemplate1,
        PreDefineTemplate2,
        // PreDefineTemplate3,
        PreDefineTemplate3,
        // PreDefineTemplate5,
        PreDefineTemplate4,
      ];
      const Component = preDefined[template.template - 1];
      return (
        Component && (
          <Component
            heading={template.media_caption}
            caption={template.tagline}
            date={template.posted_at}
            journalId={template.id}
            pageRefresh={pageRefresh}
            menuShow={true}
          />
        )
      );
    } else {
      if (template.media_url) {

        if(template?.media_type === "reel")
        {
          const VideoComponent = videoTemplates[index % videoTemplates.length];
          return (
            <VideoComponent
              heading={template.media_caption}
              caption={template.tagline}
              date={template.posted_at}
              media={template.media_url}
              journalId={template.id}
              pageRefresh={pageRefresh}
              phone={template?.phone}
              menuShow={true}
            />
          );
        }
        else{
          const ImageComponent = imageTemplates[index % imageTemplates.length];
          return (
            <ImageComponent
              heading={template.media_caption}
              caption={template.tagline}
              date={template.posted_at}
              media={template.media_url}
              journalId={template.id}
              pageRefresh={pageRefresh}
              menuShow={true}
            />
          );
        }
      } else {
        const TextComponent = textTemplates[index % textTemplates.length];
        return (
          <TextComponent
            heading={template.tagline}
            caption={template.media_caption}
            date={template.posted_at}
            journalId={template.id}
            pageRefresh={pageRefresh}
            menuShow={true}
          />
        );
      }
    }
  };

  // dnd-kit sensors
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 10, // for mouse/desktop
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 800,        // Delay before drag starts (in ms)
        tolerance: 10,      // Allow small finger movements without canceling
        distance:10,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      const oldIndex = data.findIndex((item) => item.id === active.id);
      const newIndex = data.findIndex((item) => item.id === over?.id);
      const newData = arrayMove(data, oldIndex, newIndex); // New ordered array
      setData(newData); // Update state

      const orderedIds = newData.map((item) => item.id);

      const payload = {
        phone:phone || user_phone,
        sequence:orderedIds
      }
      if(sequenceData?.length <= 0 || sequenceCreation){

        JournalAPIService.journalSequenctCreate(payload).then((response) => {
          if (response) {
            setSequenceData(response);
            setSequenceId(response.id);
            setSequenceCreation(false);
          }
        })
        .catch((err) => {
          notifyError(
            err?.response?.data?.message || API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
          );
        })
      }
      else{
        const payload ={
          sequence: orderedIds,
        }
        JournalAPIService.journalSequenctUpdate(sequenceId,payload).then((response) => {
          if (response) {
            setSequenceData(response);
          }
        })
        .catch((err) => {
          notifyError(
            err?.response?.data?.message || API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
          );
        })
      }
  }
  };

  const updateinfo = async()=>{
    let payload ={...userInfo,journalFlag:true};

    UserApiService.updateUser(phone,payload)
    .then((response) => {
      console.log("response", response);
    })
    .catch((errResponse) => {
      console.log("errResponse", errResponse);
    });

  }

  const handleCreateVideo = async () => {
    setVideoModalOpen(true);
    setDownloadJournal(false);
  };

  const handleDownloadAll = async () => {
    setVideoModalOpen(true);
    setDownloadJournal(true);

  };

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const handleVideoModalClose = () => {
    setVideoModalOpen(false);
  };

  return (
    <Container sx={{ padding: "4px" }}>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext items={data.map((d) => d.id)} strategy={rectSortingStrategy}>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0,
              padding: 1,
              minHeight: 200,
            }}
          >
            {data.map((template, index) => {
              const isLast = index === data.length - 1;
              const isVideo =
              /\.(mp4|webm|ogg|m4v|mov|avi|mkv|3gpp|3gp|3g2|hevc|h265)$/i.test(template?.media_url);
              const reelVideo=template?.media_type
              return (

                <SortableItem key={template.id} id={template.id} video={isVideo} reel={reelVideo}>
  <Box ref={isLast ? lastItemRef : null}>
      {renderTemplateComponent(template, index)}
  </Box>
</SortableItem>
              );
            })}
          </Box>
        </SortableContext>
      </DndContext>

      <FloatingActionMenu
  onSelectImages={() => console.log("Select Images Clicked")}
  onShowInfo={() => setinfoOpen(true)}
  onCreateVideo={() => handleCreateVideo()}
  onDownloadAll={() => handleDownloadAll()}
/>

{infoOpen &&
  <Dialog open={infoOpen} onClose={() => {setinfoOpen(false); updateinfo();}} maxWidth="sm" fullWidth sx={{zIndex:5000}}>
  <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.4rem", color: "#005cff",textAlign:"center" }}>
    ✨ Your Story Starts Here
  </DialogTitle>

  <DialogContent dividers>
  <Typography sx={{ mb: 1,textAlign:"center" }}>
    Just text Joy your favorite memories—photos, videos, or notes—and you'll be on your way
    to making one of the best gifts you could give future-you and your mini-me.
  </Typography>
  <Typography sx={{ mb: 2,textAlign:"center" }}>
  With Joy Journals you can:</Typography>

  {[
    { icon: "📸", text: "Edit photos & captions" },
    { icon: "🎞", text: "Make a memory reel" },
    { icon: "📥", text: "Download tiles, reels, or your full journal" },
    { icon: "🧩", text: "Move tiles around—just hold them down gently" },
  ].map(({ icon, text }, index) => (
    <Box key={index} sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}>
      <Box sx={{ minWidth: "24px", fontSize: "1.2rem", lineHeight: 1.5, mt: "-3px" }}>
        {icon}
      </Box>
      <Typography sx={{ ml: 1 }}>{text}</Typography>
    </Box>
  ))}
</DialogContent>
  <DialogActions>
    <Button onClick={() => {setinfoOpen(false); updateinfo();}} variant="contained" sx={{color:"#ffffff", background:"#005cff"}}>
      Got it!
    </Button>
  </DialogActions>
</Dialog>
}

{videoModalOpen &&
(<Dialog
  fullScreen
  open={videoModalOpen}
  onClose={() => setVideoModalOpen(false)}
  TransitionComponent={Transition}
  sx={{zIndex:2100}}
  TransitionProps={{
    onExited: () => document.body.style.overflow = "unset"
  }}
>
  <AppBar sx={{ position: "relative", background: "#005cff" }}>
    <Toolbar>
      <IconButton
        edge="start"
        color="inherit"
        onClick={() => handleVideoModalClose()}
        aria-label="close"
      >
        <ArrowLeftOutlined  />
      </IconButton>
      <Typography sx={{ ml: 2, flex: 1,fontSize:"1rem" }} variant="h6" component="div">
         {downloadJournal ? "Download Journal" : "Pick memories to make a reel"}
      </Typography>
    </Toolbar>
  </AppBar>

  {/* Pass props like data and user_phone */}
  <Box sx={{height:"calc(100% - 120px)",overflow:"hidden",overflowY:"scroll"}}>
  <MemorySelector data={data} user_phone={phone || user_phone} downloadJournal={downloadJournal} onClose={() => {setVideoModalOpen(false); pageRefresh();}} />
  </Box>
</Dialog>
)}


      {loading && (
        <>
        <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
          {/* <CircularProgress /> */}
          <img src={bundle} width="60px"/>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center"  textAlign="center" mt={2}>
          Your bundle of joy is loading... please wait a moment!
          </Box>
          </>
      )}
    </Container>
  );
}

export default MemoryRender;
